<template>
  <div>
    <div class="animate fadeIn" v-if="page || product">
      <component :is="productTemplate" v-bind="props" v-if="product" />
    </div>
    <div v-else class="p-5">
      <loader></loader>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Loader from '@/components/Loader'
  import moment from 'moment'
  const Base = require(`@/components/templates/products/base`)

  export default {
    name: 'PagePage',
    components: { Loader },
    data () {
      return {
        page: null,
        product: null,
        productTemplate: null,
        pageViewTemplate: null,
        props: {},
        pageProps: {}
      }
    },

    created () {
      let id = 0
      const path = parseInt(this.$route.path.substr(1))
      if (isNaN(path)) {
        id = this.$route.path.substr(1)
      } else {
        return this.$router.push('/')
      }
      const dt = moment()
      const targetDt = moment('2020-09-11T00:00:00+0700')
      if (id === 'main-donate' && dt.diff(targetDt) > 0) {
        // this.$router.push(`/this-meals-on-me`)
        // return
      }
      if (!id) {
        return this.$router.push(`/${Vue.config.MAIN_PRODUCT_SKU}${window.location.search}`)
      }
      this.getProduct(id)
        .then(() => {
          this.loadProductTemplate()
        })
        .catch(err => {
          console.log(err)
        })
    },

    methods: {
      getProduct (sku) {
        return this.$http.get(`products/${sku}`)
          .then(resp => {
            this.product = resp.body
            if (!this.$utils.isProductAvailable(this.product)) {
              this.$router.push('/')
            }
            this.props = {
              product: this.product
            }
          })
      },
      loadProductTemplate () {
        if (this.product && this.product.template) {
          try {
            this.productTemplate = require(`@/components/templates/products/${this.product.template}`)
          } catch (err) {
            console.log(err)
            this.productTemplate = Base
          }
        } else {
          this.productTemplate = Base
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PagePage.vue?84b34b4e